<div class="pieces-container" #piecesContainer>
  <div *ngFor="let item of pieces" class="item" pieceCheckbox [active]="item.checked" style="cursor: pointer;" [ngClass]="{'disabled': isDisabledAxis(item.value),'active' : item.checked}">
    {{item.value}}
    <input type="checkbox" style="display: none;" [(ngModel)]="item.checked" (click)="onCheckboxChange($event)"  [id]="item.id">
  </div>
</div>
